<!--
 * @Author: fangzhi fangzhi@vivo.com
 * @Date: 2023-09-27 10:58:49
 * @LastEditors: fangzhi fangzhi@vivo.com
 * @LastEditTime: 2023-10-23 15:09:13
 * @FilePath: /h5/src/views/product/detail/components/sku-select/components/sku-extra-product/index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div
    class="sku-extra-product"
    v-track="{
      act: 'show',
      params: {
        cfrom: '154|005|02|077',
        event_id: '154|005|02|077',
        source: trackSource,
        sku_id: skuId
      }
    }"
  >
    <div class="header" tabindex="0">
      <div class="title">超值加购</div>
      <div class="sub-title" :class="subDesc ? 'sub-red' : ''" v-text="subDesc ? subDesc : '精选好物随心配'"></div>
    </div>
    <div class="content">
      <productItem
        v-for="item in additionCommodityInfo"
        :additionSkuList="additionSkuList"
        :additionSpuList="additionSpuList"
        :key="item.spuId"
        :productItem="item"
        :trackSource="trackSource"
        @selectSku="selectSku"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import productItem from './components/product-item'
export default {
  components: {
    productItem
  },
  name: 'skuExtraProduct',
  props: {
    source: [Number, String] // 来源(1:已选模块;2:加入购物车;3:立即购买;4:领券购买;5:立即预约;6:一键拼团;7:立即秒杀;8:单独购买;9:镭雕;（小程序不存在鐳雕）10:全款预定;11:定金预售;12:到货通知;13:现货购买)
  },
  data() {
    //这里存放数据
    return {}
  },
  computed: {
    ...mapState('detailv3', ['additionCommodityInfo', 'selectParams', 'showAdditCommInfo']),
    ...mapGetters('detailv3', ['skuId']),
    // 埋点上报参数 1:已选模块 2:立即购买 3:镭雕 4:购物车 5:其他
    trackSource() {
      if (this.source == 1) {
        return 1
      } else if (this.source == 2) {
        return 4
      } else if (this.source == 3) {
        return 2
      } else if (this.source == 9) {
        return 3
      } else {
        return 5
      }
    },
    // 已选加购商品信息
    additionCommodity() {
      return this.selectParams.additionCommodity
    },
    // 已选加购商品的sku信息
    additionSkuList() {
      const list = []
      this.additionCommodity.forEach(el => {
        list.push(el.skuId)
      })
      return list
    },
    // 已选购商品的spuid
    additionSpuList() {
      const list = []
      this.additionCommodity.forEach(el => {
        list.push(el.spuId)
      })
      return list
    },
    subDesc() {
      let money = 0
      if (this.additionSkuList.length) {
        // 如果有选中的加购商品，则计算节省多少钱
        this.additionCommodity.forEach(el => {
          money = money + el.savePrice
        })
        // 如果有节省，则返回节省多少钱
        if (money) {
          return `共省${money}元`
        }
      }
      // 如果没节省，则计算目前显示的所有加购商品最多可以省多少钱
      if (!money) {
        this.showAdditCommInfo.forEach(el => {
          money = money + el.savePrice
        })
      }
      if (money) {
        return `最多可省${money}元`
      } else {
        // 如果没有节省，则返回空字符串，显示默认文案
        return ''
      }
    }
  },
  methods: {
    ...mapActions('detailv3', ['addAdditionCommodity', 'removeAdditionCommodity', 'updateShowAdditCommInfo']),
    selectSku(skuItem) {
      // 取消选中
      if (this.additionSkuList.includes(skuItem.skuId)) {
        this.removeAdditionCommodity(skuItem)
        this.$track({
          cfrom: '154|005|01|077',
          event_id: '154|005|01|077',
          content: skuItem.skuId,
          sku_id: this.skuId,
          clickPos: 3,
          source: this.trackSource
        })
      } else {
        if (this.additionSpuList.includes(skuItem.spuId)) {
          // 切换规格
          this.$track({
            cfrom: '154|005|01|077',
            event_id: '154|005|01|077',
            content: skuItem.skuId,
            sku_id: this.skuId,
            clickPos: 4,
            source: this.trackSource
          })
        } else {
          // 点击勾选
          this.$track({
            cfrom: '154|005|01|077',
            event_id: '154|005|01|077',
            content: skuItem.skuId,
            sku_id: this.skuId,
            clickPos: 2,
            source: this.trackSource
          })
        }
        // 选中
        this.addAdditionCommodity(skuItem)
        this.updateShowAdditCommInfo(skuItem)
      }
    }
  }
}
</script>

<style lang="scss" scoped src="./index.scss"></style>
